export default {
  checkDialog: {
    width: "xxl",
    title: "查看不规范档案",
    footer: null,
    component: () =>
      import("@/mods/archive/quickCheck/dialog/QuickCheckDialog"),
  },
};
